import React, { useState } from "react";
import { makeStyles, Box } from "@material-ui/core";
import AddCompanyComponent from "./AddCompanyComponent";
import CompaniesTable from "./CompaniesTable";

const useStyles = makeStyles(() => ({
  mainContent: {
    padding: "40px 80px"
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end"
  },
  actionButtonsContainer: {
    display: "flex",
    flexDirection: "row-reverse"
  },
  tableContainer: {
    marginTop: "10px"
  }
}));

// eslint-disable-next-line react/prop-types
export default function CompaniesComponent() {
  const classes = useStyles();
  const [refreshTableKey, setRefreshTableKey] = useState(0);

  const refreshTable = () => {
    setRefreshTableKey(refreshTableKey + 1);
  };

  return (
    <div className={classes.mainContent}>
      <Box component="div" className={classes.actionsContainer}>
        <Box component="div" className={classes.actionButtonsContainer}>
          <AddCompanyComponent onSuccess={refreshTable} />
        </Box>
      </Box>
      <Box component="div" className={classes.tableContainer}>
        <CompaniesTable refreshKey={refreshTableKey} />
      </Box>
    </div>
  );
}
